import ApiService from '@/common/api.service'

import {
  UPLOAD_VIDEO,
  GET_VIDEOS,
  GET_VIDEO_STATUS,
  GET_ALL_STREAMERS,
  CREATE_POST,
  GET_POSTS,
  UPLOAD_POST_PHOTO,
  GET_POST,
  DELETE_POST,
  GET_POST_COMMENTS,
  EDIT_POST
} from './actions.type'
import {
  SET_VIDEO_UPLOADED,
  SET_UPLOADING_VIDEO,
  SET_UPLOAD_PERCENTAGE,
  SET_VIDEOS,
  SET_VIDEO_STATUS,
  SET_ALL_STREAMERS,
  SET_IS_LOADING,
  SET_CREATED_POST,
  SET_ERROR,
  SET_POSTS,
  SET_POST,
  SET_POST_COMMENTS
} from './mutations.type'

let timeout = null

const state = {
  uploadingVideo: false,
  uploadPercentage: 0,
  videos: [],
  selectedVideoUrl: '',
  selectedVideoStatus: '',
  streamers: [],
  posts: [],
  comments: [],
  totalPage: 1,
  isLoading: false,
  error: null
}

const getters = {
  streamersName: state => {
    let name = []
    state.streamers.map(streamer => name.push(streamer.name))
    return name
  }
}

const actions = {
  async [UPLOAD_VIDEO](context, file) {
    context.commit(SET_UPLOADING_VIDEO, true)
    try {
      const res = await ApiService.uploadFile('api/v1/files/video',
        [{ key: 'file', value: file }], (percentage) => {
          context.commit(SET_UPLOAD_PERCENTAGE, percentage)
        })
      context.commit(SET_VIDEO_UPLOADED, res.data)
      return res.data
    } catch ({ response }) {
      context.commit(SET_ERROR, response.data)
      return response.data
    }
  },
  async [GET_VIDEOS](context) {
    try {
      const res = await ApiService.get('api/v1/files/video')
      context.commit(SET_VIDEOS, res.data)
    } catch ({ response }) {
    }
  },
  async [GET_VIDEO_STATUS](context, url) {
    try {
      const id = url.split('/')
      const res = await ApiService.get(`api/v1/files/video/${id[id.length - 1]}/status`)
      context.commit(SET_VIDEO_STATUS, { status: res.data.transcode.status, url })

      clearTimeout(timeout)

      timeout = setTimeout(() => {
        context.commit(SET_VIDEO_STATUS, { status: '', url: '' })
      }, 3000)
    } catch ({ response }) {
    }
  },
  async [GET_ALL_STREAMERS](context) {
    try {
      const res = await ApiService.get('api/v1/streamers/admin')
      context.commit(SET_ALL_STREAMERS, res.data)
    } catch ({ response }) {
    }
  },
  async [CREATE_POST](context, post) {
    try {
      context.commit(SET_IS_LOADING, true)
      const res = await ApiService.post('api/v1/newsfeeds', post)
      context.commit(SET_CREATED_POST, res.data)
      return res.data
    } catch ({ response }) {
      context.commit(SET_ERROR, response.data)
      return response.data
    }
  },
  async [GET_POSTS](context, page) {
    try {
      const res = await ApiService.get('api/v1/newsfeeds', `?limit=10&page=${page}`)
      context.commit(SET_POSTS, res.data)
    } catch ({ response }) {
    }
  },
  async [UPLOAD_POST_PHOTO](context, file) {
    context.commit(SET_IS_LOADING, true)
    try {
      const res = await ApiService.uploadFile('api/v1/files/upload',
        [{ key: 'upload', value: file }, { key: 'imageType', value: 'feeds' }])
      return res.data
    } catch ({ response }) {
      context.commit(SET_ERROR, response.data)
      return response.data
    }
  },
  async [GET_POST](context, id) {
    try {
      const res = await ApiService.get(`api/v1/newsfeeds/${id}`)
      context.commit(SET_POST, res.data)
    } catch ({ response }) {
    }
  },
  async [GET_POST_COMMENTS](context, { id, page }) {
    try {
      const res = await ApiService.get('api/v1/comments', `?newsFeedId=${id}&limit=20&page=${page}`)
      context.commit(SET_POST_COMMENTS, res.data)
      return res.data
    } catch ({ response }) {
    }
  },
  async [EDIT_POST](context, { id, post }) {
    try {
      context.commit(SET_IS_LOADING, true)
      const res = await ApiService.put(`api/v1/newsfeeds/${id}`, post)
      context.commit(SET_POST, res.data)
      return res.data
    } catch ({ response }) {
      context.commit(SET_IS_LOADING, false)
    }
  },
  async [DELETE_POST](context, id) {
    context.commit(SET_IS_LOADING, true)
    try {
      const res = await ApiService.delete(`api/v1/newsfeeds/${id}`)
      context.commit(SET_IS_LOADING, false)
      return res.data
    } catch ({ response }) {
      context.commit(SET_ERROR, response.data)
    }
  }
}

const mutations = {
  [SET_UPLOADING_VIDEO](state, flag) {
    state.uploadingVideo = flag
    state.isLoading = true
  },
  [SET_UPLOAD_PERCENTAGE](state, percentage) {
    state.uploadPercentage = percentage
  },
  [SET_VIDEO_UPLOADED](state, response) {
    state.uploadingVideo = false
    state.uploadPercentage = 0
  },
  [SET_VIDEOS](state, response) {
    state.videos = response.data
  },
  [SET_VIDEO_STATUS](state, { status, url }) {
    state.selectedVideoUrl = url
    state.selectedVideoStatus = status
  },
  [SET_ALL_STREAMERS](state, response) {
    state.streamers = response.data
  },
  [SET_CREATED_POST](state, response) {
    state.isLoading = false
    state.error = null
  },
  [SET_POSTS](state, response) {
    state.isLoading = false
    state.posts = response.data
    state.totalPage = response.meta.lastPage
    state.comments = []
  },
  [SET_POST](state, response) {
    state.isLoading = false
    state.post = response.data
    state.video = response.video
  },
  [SET_POST_COMMENTS](state, response) {
    state.comments.unshift(...response.data.reverse())
  },
  [SET_IS_LOADING](state, flag) {
    state.isLoading = flag
    state.error = null
  },
  [SET_ERROR](state, error) {
    state.isLoading = false
    state.uploadingVideo = false
    state.uploadPercentage = 0
    state.error = error
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
